/**
 * Vite/ESM-safe loader for npm-overlapping-marker-spiderfier.
 * The UMD bundle ends with `.call(this)`, which is undefined in ESM modules,
 * so it never attaches to window (works under Webpack script context).
 */
import omsSource from 'npm-overlapping-marker-spiderfier/lib/oms.min.js?raw';

const root = typeof globalThis !== 'undefined' ? globalThis : window;

if (typeof root.OverlappingMarkerSpiderfier !== 'function') {
  // Run as a classic script so top-level `this` is the window object.
  const script = document.createElement('script');
  script.textContent = omsSource;
  document.documentElement.appendChild(script);
  script.remove();
}

const OverlappingMarkerSpiderfier = root.OverlappingMarkerSpiderfier;

if (typeof OverlappingMarkerSpiderfier !== 'function') {
  throw new Error(
    'OverlappingMarkerSpiderfier failed to load (Vite ESM interop).',
  );
}

export default OverlappingMarkerSpiderfier;
